export default __webpack_public_path__ + "static/media/mc_idcheck.8e056c10.png";